import { attr as a } from "@microsoft/fast-element";
import { dialogStyles as g } from "./dialog.styles.js";
import { FASTDialog as c } from "@matrix42/fast-foundation";
import { dialogTemplate as y } from "./dialog.template.js";
var m = Object.defineProperty, d = (l, i, s, n) => {
  for (var e = void 0, r = l.length - 1, h; r >= 0; r--)
    (h = l[r]) && (e = h(i, s, e) || e);
  return e && m(i, s, e), e;
}, t;
const o = (t = class extends c {
  constructor() {
    super(...arguments), this.color = "primary", this.dismissible = !1, this.width = "auto";
  }
  widthChanged() {
    this.$fastController.isConnected && (this.dialog.style.width = this.width);
  }
  maxBodyHeightChanged() {
    this.$fastController.isConnected && (this._dialogBody.style.maxHeight = this.maxBodyHeight);
  }
  connectedCallback() {
    super.connectedCallback(), this.dialog.style.width = this.width, this.maxBodyHeight && (this._dialogBody.style.maxHeight = this.maxBodyHeight), t._resizeObserver.observe(this._dialogBody);
  }
  disconnectedCallback() {
    super.disconnectedCallback(), t._resizeObserver.unobserve(this._dialogBody);
  }
  invalidateOverflow() {
    this._dialogBody.scrollHeight > this._dialogBody.clientHeight ? this._dialogFooter.classList.add("overflow-border") : this._dialogFooter.classList.remove("overflow-border");
  }
  static onResize(i) {
    for (const s of i)
      s.target.getRootNode().host.invalidateOverflow();
  }
}, t.definition = {
  name: "dialog",
  template: y,
  styles: g
}, t._resizeObserver = new ResizeObserver(t.onResize), t);
d([
  a
], o.prototype, "color");
d([
  a({ mode: "boolean" })
], o.prototype, "dismissible");
d([
  a
], o.prototype, "width");
d([
  a
], o.prototype, "maxBodyHeight");
let w = o;
export {
  w as Dialog
};
